import styled from 'styled-components';

export const StyledLine = styled.div`
    height: 1px;
    width: 100%;
    background-color: #cccccc;
    margin: 10px 0;
`;
